export default {
  current: {
    contacts: [],
    categories: [],
  },
  files: {},
};



// WEBPACK FOOTER //
// ./src/app/store/modules/quote/state.js